// default config
export default {
  language: { name: 'English', code: 'en', rtl: false },
  languages: [
    {
      code: 'en',
      dir: 'ltr',
      name: 'English',
    },
  ],
  currency: {
    locale: 'en-AU',
    code: 'AUD',
  },
  labels: {
    details: {
      en: 'Details',
      ar: 'التفاصيل'
    },
    dwellingLabel: { en: 'Design' },
    dwellingBuilder: { en: 'Builder' },
    dwellingDesign: { en: 'Design' },
    dwellingSize: { en: 'Living Area' },
    dwellingFeatures: { en: 'Features' },
    dwellingDescription: { en: 'description' },
    dwellingPrice: { en: 'Price' },
    dwellingBeds: { en: 'Beds' },
    dwellingBaths: { en: 'Baths' },
    dwellingCars: { en: 'Cars' },
    propertyLabel: { en: 'Lot Number' },
    propertySize: { en: 'Land Area' },
    propertyPrice: { en: 'Price' },
    frontage: { en: 'Frontage' },
    depth: { en: 'Depth' },
    description: {
      en: 'Description',
      ar: 'وصف',
    },
    exploreCommunities: {
      en: 'Explore Communities',
      ar: 'استكشاف المجتمعات'
    },
    features: {
      en: 'Features',
      ar: 'المواصفات​',
    },
    openingHours: {
      en: 'Opening Hours',
      ar: 'ساعات العمل',
    },
    backButton: {
      en: 'Back',
    },
    favouritesButton: {
      en: 'View Favourites',
      ar: 'عرض المفضلة'
    },
    addToFavourites: {
      en: 'Add to Favourites',
      ar: 'أضف إلى المفضلة'
    },    
    available: {
      "en": "Available",
      "ar": "متاح"
    }, 
    onHold: {
      "en": "On Hold",
      "ar": "لم يطلق"
    },
    sold: {
      "en": "Sold",
      "ar": "مباع"
    },
    viewLabel: {
      "en": "Aspect",
    }
  },

  skipOnlyChildSubsections: true,

  showRegistrationModalOnQr: true,

  // Legacy options
  general: {
    showFavourites: true,
    showArtistImpressionText: true,
    artistImpressionPosition: 'bottom-right',
    showOnHoldGraphic: false,
    showSensorealBranding: true,
    showHomeButton: false,
    showPackagesWithSoldLots: false, // not implemented
    showSoldNeighbourhoods: true,
    showSoldReleases: true, // not implemented
    showSoldSlides: false,
    showSoldLabel: false,
    showSoldPrice: false,
    showLayoutSwitchToggle: true,
    canInteractSoldLivingoptions: true,
    canInteractSoldSubsections: true, // not implemented
    canInteractSoldProperties: true,
    disclaimer: "",
    selectorHost: "", // not used here?
    selectorName: "", // not used here?
    analytics: false,
    ignorePropertyStatusFiltering: [""],
    showPrice: true,
    appResetTimeoutMinutes: 15,
  },

  filter: {
    enabled: false,

    propertyType: true,
    propertyView: true,
    propertyLotSize: true,
    propertyPriceRange: true,
    propertyStatus: true,
    dwellingDisplayName: true,
    dwellingBeds: true,
    dwellingBaths: true,
    dwellingCars: true,
    dwellingSize: true,
    dwellingPrice: true,
  },

  hideLivingoptionSlides: false,

  landPage: {
    active: true,
    label: ""
  },
  
  turnkeyPage: {
    active: false,
    label: "Townhomes",
    types: ["land", "house", "townhouse"]
  },

  dwellingPage: {
    active: false,
    label: "",
    types: ["house", "townhouse", "apartment"]
  },

  packagePage: {
    active: false,
    label: ""
  },

  displayHomesPage: {
    active: false,
    label: "Display Village"
  },

  propertyCard: {
    headingColour: "",
    priceLabel: {
      land: "Land Price From",
      package: "Package Price",
      dwelling: "House Price From",
      turnkey: "Price"
    }    
  },

  propertyModal: {
    showSuitableDwellingsButton: false,
    suitableDwellingsButtonLabel: "House Options", 
    associatedPackagesButtonLabel: "View Packages" 
  },

  rightSidebar: {
    propertyGuide: {
      active: true,
      items: [
        {
          "en": "Available",
          "ar": "متاح"
        },        
        {
          "en": "On Hold",
          "ar": "لم يطلق"
        },
        {
          "en": "Sold",
          "ar": "مباع"
        }
      ]
    }
  },

  markerIcons: {
    land: ["far", "check"],
    house: ["far", "check"],
    townhouse: ["far", "check"],
    apartment: ["far", "check"]
  }
}
